export default {
  explanation: {
    peripheral:
      '1、本栏目显示客户环境采集的外设信息（包括型号、接口及对应业务场景）\r\n2、如果外设已在云桌面产品上做过兼容测试，会打上兼容标签\r\n3、所有外设默认选中，并输出到测试方案进行测试，也可以点击取消选中不进行售前测试\r\n4、可以通过 + 号进行额外添加外设进行补充用例测试',
    software:
      '1、本栏目显示客户环境采集的软件信息（包括名称、版本及对应业务场景）\r\n2、如果软件已在云桌面产品上做过兼容测试，会打上兼容标签\r\n3、所有软件默认选中，并输出到测试方案进行测试，也可以点击取消选中不进行售前测试\r\n4、可以通过 + 号进行额外添加软件进行补充测试',
    terminal:
      '1、本栏目显示客户环境、场景推荐或手工添加的终端信息（型号、CPU、内存、硬盘、场景等信息）\r\n2、终端选中说明测试方案中会根据输出相应的终端进行售前测试\r\n3、终端（桌面）可以进行数量编辑以符合客户实际场景需要的数量',
    server:
      '1、本栏目显示场景推荐的服务器型号，支持添加其它自研服务器或第三方服务器\r\n2、服务器类型分为支持IDV模式与VDI模式\r\n3、VDI模式需要进行服务器资源及数量计算，IDV模式则不需要',
    loadSpec:
      '1、本栏目用于计算服务器资源，主要决定元素有：CPU核数、内存、磁盘大小及需要的桌面总数\r\n2、CPU、内存、磁盘根据对应场景采集的客户终端信息并以1：1进行计算资源，如果没有采集则需要手工进行输入\r\n3、如果客户有多场景采集数据则本栏目列表有多条记录\r\n4、同一场景下支持使用多款VDI终端或软客户端',
    dualScreen: '客户使用场景中是否有需要双屏模式',
    replicationStrategy:
      '存储副本策略\r\n1、2D(2副本存储池)：存储集群最少需要2个节点，建议不少于3个节点，每个节点容量盘不少于1块，存储池空间利用率50%。\r\n2、3D(3副本存储池)：存储集群最少需要3个节点，建议不少于4个节点，每个节点容量盘不少于1块，存储池空间利用率33.33%。\r\n3、2D1P(纠删2数据1校验存储池)：存储集群最少需要3个节点，建议不少于4个节点，每个节点容量盘不少于1块，存储池空间利用率66.66%。\r\n4、4D1P(纠删4数据1校验存储池)：存储集群最少需要5个节点，建议不少于6个节点，每个节点容量盘不少于1块，存储池空间利用率80%。\r\n5、4D2P(纠删4数据2校验存储池)：存储集群最少需要6个节点，建议不少于7个节点，每个节点容量盘不少于1块，存储池空间利用率66.66%。\r\n6、8D2P(纠删8数据2校验存储池)：存储集群最少需要10个节点，建议不少于11个节点，每个节点容量盘不少于1块，存储池空间利用率80%。\r\n \r\n 冗余策略对比\r\n1、副本策略是指一份数据以副本的方式写到多个分布式系统中的存储节点中，此策略仅在所有副本所在的存储节点都故障，才会影响业务。此外，可以从未故障的其他副本读取数据以保证业务。但是多副本的空间利用率偏低，如3副本策略，存储空间利用率为33.33%，这增加了存储成本\r\n2、纠删码策略，是指将N份原始数据，增加M份数据，并能通过N+M份中的任意N份数据，还原为原始数据。如果把N+M份数据分布在存储系统的不同节点上，那么任意小于等于M个节点故障（M份数据失效），都可以通过其它剩余的数据还原出原始数据，从而达到不影响业务的目的。从空间利用率上，纠删码策略优于多副本，以纠删2数据1策略和2副本策略为例，纠删2数据1策略的利用率达到66.66%，比2副本空间利用率提高16.67%。但是在可靠性上，与2副本一样可以满足支持单节点故障。',
    ha: '客户环境是否需要系统能够持续提供服务而不中断的能力，即：最少需要三台服务器',
    singleDisk: '服务器单块磁盘的容量配置',
    slot: '服务器除了系统盘，缓存盘，显卡占用，最后剩余的数据盘可用槽位数',
    cms: 'CMS云盘空间大小',
    selectedServer:
      '1、本栏目用于确定运行云桌面的服务器资源或终端数量\r\n2、需要选择对应参数进行计算，包括：负载规格选择、是否双屏、存储副本策略、高可用、单盘容量、服务器槽位、CMS云盘空间、服务器型号及CPU类型，最终计算出服务器节点数、单节点内存、单盘容量个数',
    imageOs: '本栏目显示客户环境下使用的云桌面操作系统类型',
    appOs: '云应用包含云坞、独享/共享应用虚拟化',
    hostOs: '本栏目显示客户环境下使用的锐捷工作空间或云坞宿主机操作系统类型',
    firewall: '终端到服务器是否有防火墙',
    ipMacBind: '桌面内是否绑定IP与MAC',
    vpn: '是否使用了虚拟专用网络',
    nat: 'SAG到服务器是否存在NAT网络',
    networkSpeed: '客户环境服务器与终端网络速度情况',
    specNameDesc: '',
    networkPort: '需要服务器提前开启的网络端口：1-65535之间',
    schoolTest:
      '1、仅校内考试：VDI桌面可以满足,推荐CT1000-G2\r\n 2、如果不止校内考试，还得承接各类社会考试，那就要要求本地桌面考试，需要推荐CT1000-G2',
    design3D: '',
    doubleScreen: '单屏：虚机外消耗0.55G内存。\r\n双屏：虚机外消耗0.9G内存。',
    highIo:
      '3D专业机房、工科实训机房、财经类机房默认要求高IO存储配置。\r\n公共机房如果有财会类（如U8）、视频特效类（如AE）等需要高磁盘IO的软件，需要选择“有高IO”，配置全闪存储池方案。',
    onlineTraining:
      '是：服务器硬件需要按超融合配置，如网卡至少要配置为2千2万。\r\n否：服务器硬件可以按照云课堂分层超融合配置，如网卡可以配置为4个千兆。',
    rendering:
      '1、无需渲染：无渲染要求，模拟显卡可以满足，无需推荐配置vGPU。\r\n2、AMD显卡可以满足：有轻度渲染要求，但使用CPU渲染可以满足，推荐配置AMD vGPU显卡。\r\n3、要求NVIDIA显卡：务必推荐配置Nvidia型号显卡，使用AMD显卡存在兼容问题。',
    antivirusSoftware: '如果有杀毒软件，服务器带机量会相应减少百分比数值',
    encrpytionSoftware: '如果有加密软件，服务器带机量会相应减少百分比数值',
    desktopElementList: '影响云桌面模版配置的因素，云桌面中每个配置的值大小都是由桌面资源影响因子对应配置取最大值',
    desktopResourceList:
      '1、一个场景可支持不同配置的云桌面\r\n2、云桌面默认推荐值来至桌面元素列表计算得来，每个属性的对应值都是取最大值',
    terminalSelect: '本栏目显示场景推荐的终端型号',
    calServer: '本栏目显示场景推荐的服务器型号',
    calServerCpu: '',
    calServerGpu:
      '1、V520，显卡切分为["0.8","0.9","1","1.1","1.25","1.4","1.6","2","2.5","3.3","5","10"]\r\n 2、CG620，显卡切分为["2.6","2.9","3.2","3.5","4","4.5","5.3","6.4","8","10.6","16","32"]\r\n3、A40，显卡切分为["3","4","6","8","12","16","24","48"]\r\n4、A16，显卡切分为["2","4","8","16"]',
    calServerGpuNumber: '1、V520支持最大5张\r\n2、CG620支持最大3张\r\n3、A40支持最大2张\r\n4、A16最大支持1张',
    serverSysDisk: '用来运行服务器OS，默认标配1*480G SSD。\r\n如客户要求系统盘组Raid，可以选择2*480G SSD',
    serverSysDiskNumber: '',
    serverCacheDisk:
      'POS超融合存储的缓存空间；默认标配1*480G SSD,缓存盘阅读，存储读IO越高。默认配置下，最大支持管理960GB缓存盘空间。',
    serverCacheDiskNumber: '',
    openPortList: '网络安全要求高的环境方便提前让客户放通端口',
    desktopSysDisk: '该系统盘规格主要提供给桌面模版中虚机的系统盘使用',
    desktopDataDisk: '该数据盘规格主要提供给桌面模版中虚机的数据盘使用',
    memorySpec: '服务器内存条规格大小',
    portOpen: '开启：开放常规默认端口\r\n关闭：关闭常规默认端口',
    localDiskType:
      '机房还原桌面推荐使用本地单幅本池，有更好的启动速度和读写IO；\r\n个性桌面无法使用单幅本池，所以不需要配置本地单副本池；\r\n要求≥1块HDD或SSD（HDD要求7200rpm企业级，SSD要求企业级）；当有【高IO存储要求】时仅支持选择固态盘；NVME磁盘IO优势很大，预算允许时优先选择',
    generateSize: '学生每次上课或者上机，通过操作软件所产生的落旁数据大小',
    desktopType: ''
  },
  question: {
    desktopType: '',
    generateSize: '',
    localDiskType: '',
    terminal: '客户端类型有哪些？\r\n答：包括：IDV终端、VDI终端、TCI终端、利旧PC、软客户端（Windows、IOS、安卓版本）',
    server: '服务器资源计算条件有哪些？\r\n答：主要包括支持VDI模式的服务器与支持VDI模式的终端或软客户端',
    peripheral: '',
    software: '',
    loadSpec: '',
    dualScreen: '',
    replicationStrategy: '',
    ha: '',
    singleDisk: '',
    slot:
      '为什么最多只能10个槽位？ \r\n答：因为服务器一般最多12个槽位，扣除系统盘、缓存盘后仅剩下10个，因此最多只能10个槽位',
    cms: '',
    selectedServer: '',
    imageOs: '',
    appOs: '',
    hostOs: '',
    firewall: '',
    ipMacBind: '',
    vpn: '',
    nat: '',
    networkSpeed: '',
    specNameDesc: '',
    networkPort: '',
    schoolTest: '',
    design3D: '',
    doubleScreen: '',
    highIo: '',
    onlineTraining: '',
    rendering: '',
    antivirusSoftware: '',
    encrpytionSoftware: '',
    desktopElementList: '',
    desktopResourceList: '',
    terminalSelect: '',
    calServer: '',
    calServerCpu: '',
    calServerGpu: '',
    calServerGpuNumber: '',
    serverSysDisk: '',
    serverSysDiskNumber: '',
    serverCacheDisk: '',
    serverCacheDiskNumber: '',
    desktopSysDisk: '',
    desktopDataDisk: '',
    memorySpec: '',
    openPortList: '',
    portOpen: ''
  },
  confirm: {
    terminalMng: {
      deleteMsg: '删除终端：{model} 配置吗？'
    },
    pocMng: {
      deletePocProject: '删除项目吗？'
    },
    productMng: {
      deleteMsg: '删除产品配置吗？'
    },
    industryMng: {
      deleteMsg: '删除行业：{industryName} 配置吗？'
    },
    sceneMng: {
      deleteMsg: '删除场景：{sceneName} 配置吗？'
    },
    featureMng: {
      deleteMsg: '删除功能：{featureName} 配置吗？'
    },
    caseSoftwareMng: {
      deleteMsg: '删除软件用例：{testCaseName} 配置吗？'
    },
    casePeripheralMng: {
      deleteMsg: '删除外设用例：{testCaseName} 配置吗？'
    },
    deliveryGuideMng: {
      deleteMsg: '删除指导配置：{docName} 吗？'
    },
    caseBusiMng: {
      deleteMsg: '删除功能用例：{testCaseName} 配置吗？'
    },
    testCaseShared: {
      deleteMsg: '删除共享用例：{testCaseName} 配置吗？'
    },
    softwareMng: {
      deleteMsg: '删除软件：{softwareName} 配置吗？'
    },
    osTypeMng: {
      deleteMsg: '删除操作系统：{osType} 配置吗？'
    },
    serverMng: {
      deleteMsg: '删除服务器：{serverName} 配置吗？'
    },
    peripheralMng: {
      deleteMsg: '删除外设：{name} 配置吗？'
    },
    softwareBlackListMng: {
      deleteMsg: '删除黑名单：{blackContent} 吗？'
    },
    positionMng: {
      deleteMsg: '删除岗位：{positionName} 吗？'
    },
    npsStrategyMng: {
      deleteMsg: '删除工具NPS策略：{toolName} 配置吗？',
      refreshStrategyMsg: '重新开启对所选工具进行NPS采集吗？'
    }
  }
}
